import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserForcePasswordUpdate } from '../../../actions/spaces/SiteUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSelectingSomethingOtherThanGuest } from './IEntityActionHelpers';
import { ServerSettingsUnauthenticated } from '../../../../settings/services/ServerSettingsUnauthenticated';

export const SiteUserForcePasswordUpdateAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserForcePasswordReset,
  translateName: Messages.forcePasswordUpdate_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthPasswordExpirationEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return isSelectingSomethingOtherThanGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserForcePasswordUpdate(targetItems)
};
